import { isRequired, isEmail } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email, 'Incorrect email value')) {
    errors.email = 'Incorrect email value';
  }

  if (isRequired(values.phoneNumber || '', true)) {
    errors.phoneNumber = 'Phone is required';
  }

  return errors;
};

export default validate;
